export default __webpack_public_path__ + "static/media/sponsor-bg-2.6563f904.webp";